import * as React from 'react';
import loading3 from '../assets/images/loading3.gif';

export const ApplicationLoader = ({ loader }) => loader && (
    <div
        style={{
            position: "absolute",
            top: 0,
            left: 0,
            height: '100vh',
            backgroundPosition: 'center',
            backgroundImage: `url(${loading3})`,
            backgroundRepeat: 'no-repeat',
            zIndex: 9999,
            width: '100vw',
            opacity: 0.5,
            backgroundColor: "#f2f5f8",
        }}
    >
    </div>
);

const LoaderContext = React.createContext(null);

export const useLoaderContext = () => React.useContext(LoaderContext);

export const LoaderContextProvider = ({ children }) => {

    const [loader, setLoader] = React.useState(false);

    return (
        <LoaderContext.Provider value={setLoader}>
            {children}
            <ApplicationLoader loader={loader} />
        </LoaderContext.Provider>
    );
};
